import React from 'react'

const SingleSide = ({ item }) => (
  <div className="col flex-fill">
    <div className="card width-100-percent">
      <div className="card-image">
        <img className="" alt={item.title} src={item.urlToImage} />
        <span className="card-title">{item.source.name}</span>
      </div>
      <div className="card-content">
        <p>{item.title}</p>
      </div>
      <div className="card-action">
        <a href={item.url} target="_blank" rel="noopener noreferrer">
          Full Article
        </a>
      </div>
    </div>
  </div>
)
export default SingleSide
